// import isWebview from 'is-ua-webview';
import { FC, useState, useEffect } from "react";
import { Link } from "react-router-dom";

import * as Meta from 'meta';
import { ROUTE } from "route";
import { gaEvent, isBuilding, isDailyAdult } from "utils";
import { Modal, Notice, Step } from "components";

import { Header, Footer } from "components";

export const HomePage: FC = () => {
  const [isShowNotice, setIsShowNotice] = useState(false);
  const [isShowStep, setIsShowStep] = useState(false);

  const handleShowNotice = (isShow: boolean) => {
    setIsShowNotice(isShow);
  };

  const handleShowStep = (isShow: boolean) => {
    setIsShowStep(isShow);
  };

  useEffect(() => {
    if(!isBuilding() && isDailyAdult()) {
      document.getElementById('wrapper').style.display = 'block';
    }
  }, []);

  return (
    <div id="wrapper" className="wrapper" style={{ display: 'none' }}>
      {Meta.loadCSS(['index', 'notice', 'step'])}
      {Meta.loadJS(['main-0625', 'index-0625'])}
      {Meta.ga("活動頁面")}
      <Header />
      <div className="main">
        <div className="kv">
          <img className="kv_wave kvw1" src="/resources/html/images/index/kv_w1.png" />
          <img className="kv_wave kvw2" src="/resources/html/images/index/kv_w2.png" />
          <img className="kv_wave kvw3" src="/resources/html/images/index/kv_w3.png" />
          <img className="kv_wave kvw4" src="/resources/html/images/index/kv_w4.png" />
          <div className="kv_main"><img src="/resources/html/images/index/kv_main.png" /></div>
          <div className="kv_text"><img src="/resources/html/images/index/kv_title.png" /></div>
          <div className="kv_product1"><img src="/resources/html/images/index/kv_pd1.png" /></div>
          <div className="kv_product2"><img src="/resources/html/images/index/kv_pd2.png" /></div>
          <div className="kv_people1"><img src="/resources/html/images/index/kv_p1.png" /></div>
          <div className="kv_people2"><img src="/resources/html/images/index/kv_p2.png" /></div>
        </div>

        <section className="activity">
          <div className="inner">
            <div className="title mt">
              <div className="title_t">爽啤一開，爽勁就來</div>
              <div className="title_bg"><img src="/resources/html/images/title_bg.png" /></div>
            </div>
            <div className="activity_info mp">
              <p>
                爽啤QRcode抽獎活動已於2021/8/11結束，謝謝參與！
              </p>
            </div>
            <ul className="activity_btbox">
              <li className="notice_open ml" onClick={() => {
                gaEvent('活動頁面', 'btn_活動辦法及注意事項');
                setIsShowNotice(true);
              }}>活動<span className="bt_mb">辦法<br />及注意</span>事項</li>
              <li className="step_open mb" onClick={() => {
                gaEvent('活動頁面', 'btn_我的暢快爽勁活動流程說明');
                setIsShowStep(true);
              }}><span className="bt_mb">我的暢快爽勁<br /></span>活動流程<span className="bt_mb">說明</span></li>
              <Link to={ROUTE.WINNER} onClick={gaEvent.bind(null, '活動頁面', 'btn_得獎公告')}><li className="mr">得獎公告</li></Link>
            </ul>
          </div>
          <div className="wave w1 ml"><img src="/resources/html/images/index/wave01.png" /></div>
          <div className="wave w2 mr"><img src="/resources/html/images/index/wave02.png" /></div>
          <div className="other o1 mr"><img src="/resources/html/images/t3.png" /></div>
          <div className="other o2 ml"><img src="/resources/html/images/t5.png" /></div>
        </section>
        <a id="songprize" />
        <section className="prize" id="songprize">
          <div className="prize_oil">
            <div className="inner">
              <div className="prize_titlebox mr">
                <div className="prize_circle">
                  <span>暢快爽勁<br />第<span className="special">1</span>發</span>
                </div>
                <div className="prize_title">
                  <span
                  >爽爽好禮即掃即抽<br />【爽啤X油頭二世】限量獨家好禮</span
                  >
                </div>
              </div>
              <div className="prize_info mp">
                <p>活動期間內拿起您的罐裝爽啤<br />撕開活動貼紙掃描罐身QRcode<br />並完成登錄就可立即抽<br />【爽啤x油頭二世】聯名好禮</p>
              </div>
              <div className="oil_all mt"><img src="/resources/html/images/allprize.png" alt="【爽啤X油頭二世】爽爽好禮" /></div>
              <div className="oil_product">
                <div className="oil_pd">
                  <img
                    className="ms"
                    src="/resources/html/images/trunk.png"
                    alt="【爽啤X油頭二世】爽走天下行李箱"
                  />
                  <div className="oil_name mt">
                    <p className="hightlight">爽走天下行李箱<br /><span className="oil_sticker">(20吋/黑白顏色隨機)</span></p>
                    <p>- 50名 -</p>
                  </div>
                </div>
                <div className="oil_pd">
                  <img
                    className="ms"
                    src="/resources/html/images/icebox.png"
                    alt="【爽啤X油頭二世】沁涼爽勁冰桶"
                  />
                  <div className="oil_name mt">
                    <p className="hightlight">沁涼爽勁冰桶<br /><span className="oil_sticker">(12.5L)</span></p>
                    <p>- 50名-</p>
                  </div>
                </div>
                <div className="oil_pd">
                  <img
                    className="ms"
                    src="/resources/html/images/cup380.png"
                    alt="【爽啤X油頭二世】不銹鋼爽勁杯"
                  />
                  <div className="oil_name mt">
                    <p className="hightlight">不銹鋼爽勁杯<br /><span className="oil_sticker">(380ml)</span></p>
                    <p>- 150名-</p>
                  </div>
                </div>
                <div className="oil_pd">
                  <img
                    className="ms"
                    src="/resources/html/images/cup510.png"
                    alt="【爽啤X油頭二世】不銹鋼爽呼呼杯"
                  />
                  <div className="oil_name mt">
                    <p className="hightlight">不銹鋼爽呼呼杯<br /><span className="oil_sticker">(510ml)</span></p>
                    <p>- 150名 -</p>
                  </div>
                </div>
                <div className="oil_pd">
                  <img
                    className="ms"
                    src="/resources/html/images/picnic.png"
                    alt="【爽啤X油頭二世】悠閒舒爽野餐"
                  />
                  <div className="oil_name mt">
                    <p className="hightlight">悠閒舒爽野餐墊<br /><span className="oil_sticker">(146*168 cm)</span></p>
                    <p>- 200名 -</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="wave w3 ml"><img src="/resources/html/images/index/wave03.png" /></div>
            <div className="wave p1 mb">
              <img src="/resources/html/images/index/people01.png" />
            </div>
            <div className="wave l1 mr"><img src="/resources/html/images/index/oil2.png" /></div>
            <div className="wave p2 mt">
              <img src="/resources/html/images/index/people02.png" />
            </div>
            <div className="other o3 ml"><img src="/resources/html/images/t4.png" /></div>
            <div className="other o5 mr"><img src="/resources/html/images/t1.png" /></div>
            <div className="other o7 mr"><img src="/resources/html/images/intro/intro_left.png" /></div>
            <div className="other o8 ml"><img src="/resources/html/images/intro/intro_right.png" /></div>
          </div>
          <div className="prize_week">
            <div className="inner">
              <div className="prize_titlebox mr">
                <div className="prize_circle">
                  <span
                  >暢快爽勁<br /><span className="special num">2</span>連發</span
                  >
                </div>
                <div className="prize_title">
                  <span>最爽好禮週週抽<br />【時尚生活X享樂人生】大禮</span>
                </div>
              </div>
              <div className="prize_info mp">
                <p>
                    延續爽勁! 爽勁最好禮! 週週再抽大獎!<br />QRcode掃得越多，中獎機率越大!
                </p>
              </div>
              <div className="week_product">
                <div className="week_pd">
                  <img
                    className="ms"
                    src="/resources/html/images/week1.png"
                    alt="【爽啤X油頭二世】爽走天下行李箱"
                  />
                  <div className="week_name mt">
                    <p className="hightlight">
                      PlayStation 5 Digital Edition
                      <br className="special_br" />
                      <span style={{display: 'inline-block'}}>遊戲主機</span>
                    </p>
                    <p>- 共2名 -</p>
                  </div>
                </div>
                <div className="week_pd">
                  <img
                    className="ms"
                    src="/resources/html/images/week2.png"
                    alt="【爽啤X油頭二世】沁涼爽勁冰桶"
                  />
                  <div className="week_name mt">
                    <p className="hightlight">Nintendo Switch<br />紅藍主機</p>
                    <p>- 共2名 -</p>
                  </div>
                </div>
                <div className="week_pd">
                  <img
                    className="ms"
                    src="/resources/html/images/week3.png"
                    alt="【爽啤X油頭二世】不銹鋼爽勁杯"
                  />
                  <div className="week_name mt">
                    <p className="hightlight">Apple iPad8<br />平板電腦</p>
                    <p className="week_small">(10.2吋/Wi-Fi/32GB/顏色隨機)</p>
                    <p>- 共2名 -</p>
                  </div>
                </div>
                <div className="week_pd">
                  <img
                    className="ms"
                    src="/resources/html/images/week4.png"
                    alt="【爽啤X油頭二世】銹鋼爽呼呼杯"
                  />
                  <div className="week_name mt">
                    <p className="hightlight">Marshall Acton ll<br />藍芽喇叭</p>
                    <p className="week_small">(顏色隨機)</p>
                    <p>- 共2名 -</p>
                  </div>
                </div>
              </div>
              <div className="week_btbox">
                <Link to={ROUTE.SCAN} onClick={gaEvent.bind(null, '活動頁面', 'btn_立即掃描QRcode')}>
                  <li>立即掃描<br />QRcode</li>
                </Link>
                <Link to={ROUTE.RECORD} onClick={gaEvent.bind(null, '活動頁面', 'btn_登錄查看抽獎紀錄')}>
                  <li>登錄查看<br />抽獎紀錄</li>
                </Link>
              </div>
            </div>
            <div className="other o4 ml"><img src="/resources/html/images/op2.png" /></div>
            <div className="other o6 mr"><img src="/resources/html/images/t2.png" /></div>
            <div className="wave w4 mr"><img src="/resources/html/images/index/wave04.png" /></div>
          </div>
          <div className="wave w5 ml"><img src="/resources/html/images/index/wave05.png" /></div>
          <div className="wave w6 mr"><img src="/resources/html/images/index/wave06.png" /></div>
        </section>
      </div>
      <Footer />
      {isShowNotice &&
            <Modal onClose={handleShowNotice}><Notice /></Modal>
      }
      {isShowStep &&
            <Modal onClose={handleShowStep}><Step /></Modal>
      }
      <div className="scroll_top"><span>TOP</span></div>
    </div>
  );
};
